module.exports = __webpack_public_path__ + "img/dots-vertical.8679ca64.svg";